import type { RouteLocationRaw } from 'vue-router'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { canPage } from '@/@layouts/plugins/casl'
import navigation from '@/navigation/vertical'

type NavigationEntry = { heading?: unknown; page?: unknown; children?: NavigationEntry[] }

const pages = (items: NavigationEntry[]): unknown[] =>
  items.flatMap(entry => {
    const childPages = Array.isArray(entry.children) ? pages(entry.children) : []

    if (!entry.page) return childPages

    return [entry.page, ...childPages]
  })

const landingPages = [...pages(navigation), PageMeta.AiWorkspace.Chat]

export const notAuthorizedRoute = {
  name: (PageMeta.Auth.notAuthorized as { name: string }).name,
} as RouteLocationRaw

export const admittedLandingRoute = (): RouteLocationRaw | null => {
  for (const page of landingPages) {
    if (!page || typeof page !== 'object') continue

    const candidate = page as { name?: unknown; Name?: unknown }
    const name = candidate.name ?? candidate.Name

    if (typeof name !== 'string' || !canPage(page)) continue

    return { name } as RouteLocationRaw
  }

  return null
}
